module.exports = __webpack_public_path__ + "static/main-5fc57dbcc70aa6db60bf2e3670228642.jpg";